
import Maps from './../../components/Maps/Maps';

export default function Contacts(){
    return(
        <div>
            <Maps/>
        </div>
    )
}